import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';
import { AuthRoutes } from './auth';
import { PublicRoutes } from './public';
import { DashboardRoutes } from './dashboard';
import { ComponentRoutes } from './components';
import { LoadingProgress } from '@/components/loader';

// GLOBAL ERROR PAGE
const ErrorPage = lazy(() => import('@/pages/404'));

// INVITATION PAGE (PUBLIC - NO AUTH REQUIRED)
const InvitationResponse = lazy(() => import('@/pages/invitations/invitation-response'));

export const routes = () => {
  return [
  // INITIAL / INDEX PAGE - REDIRECT TO LOGIN
  {
    path: '/',
    element: <Navigate to="/login" replace />
  },
  // INVITATION RESPONSE PAGE (PUBLIC - NO AUTH REQUIRED)
  {
    path: 'invitations/:token',
    element: (
      <Suspense fallback={<LoadingProgress />}>
        <InvitationResponse />
      </Suspense>
    )
  },
  // GLOBAL ERROR PAGE
  {
    path: '*',
    element: <ErrorPage />
  },
  // AUTHENTICATION PAGES ROUTES & DIFFERENT AUTH DEMO PAGES ROUTES
  ...AuthRoutes,
  // COMPONENTS PAGES ROUTES
  ...ComponentRoutes,
  // INSIDE DASHBOARD PAGES ROUTES
  ...DashboardRoutes,
  // PAGES ROUTES
  ...PublicRoutes];
};